import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {BehaviorSubject, EMPTY, from, Observable, of} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {concatMap, finalize, map} from 'rxjs/operators';

const baseUrl = `${environment.apiUrl}/accounts`;

@Injectable({
    providedIn: 'root'
})
export class FBAccountService {
    private accountSubject: BehaviorSubject<Account>;
    public account: Observable<Account>;
    private fboptions: any;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient
    ) {
        this.accountSubject = new BehaviorSubject<Account>(null);
        this.account = this.accountSubject.asObservable();
        this.fboptions = {
            scope: 'business_management,whatsapp_business_management',
            extras: {
                feature: 'whatsapp_embedded_signup',
                setup: {
                    
                }
            }
        }
    }

    public get accountValue(): Account {
        return this.accountSubject.value;
    }

    embededSignin() {
        // login with facebook and return observable with fb access token on success
        return from(new Promise<fb.StatusResponse>(resolve => FB
            .login(resolve, this.fboptions)))
            .pipe(concatMap(({ authResponse }) => {
                if (!authResponse) return EMPTY;
                return of(authResponse.accessToken);
            }));
    }
}
